import { Typography } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"

export const TitleText = withStyles({
    root: {
        color: "#FFFFFF",
        paddingBlockEnd: "0.5rem",
    }
})(Typography);
